const ERC20_ABI = [
  // TODO @@ walletConnect - wrong ABI
  // {
  //   type: 'function',
  //   name: 'transfer',
  //   stateMutability: 'nonpayable',
  //   inputs: [
  //     {
  //       name: 'recipient',
  //       type: 'address',
  //     },
  //     {
  //       name: 'amount',
  //       type: 'uint256',
  //     },
  //   ],
  //   outputs: [],
  // },
  {
    name: 'transfer',
    type: 'function',
    inputs: [
      {
        name: '_to',
        type: 'address',
      },
      {
        type: 'uint256',
        name: '_tokens',
      },
    ],
    constant: false,
    outputs: [],
    payable: false,
  },
] as const;

export default ERC20_ABI;
